import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import store from '@/store/index'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'
import requestJdproductRegister from './request/requestJdproductRegister'
import requestJdproductEdit from './request/requestJdproductEdit'
import { i18n } from '@/main.js'

const Actions = {
  // ESJ01 JD販売商品情報の取得
  getJdproductListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      // .get(apiMock.JDPRODUCT_LIST)
      .get(api.JDPRODUCT_LIST, { params: params })
      .then((response) => {
        const path = mutationsTypes.JDPRODUCT_SET_JDPRODUCT_LIST
        commit(path, response.data)
        commit(mutationsTypes.JDPRODUCT_SET_META, response.data)
        // csv履歴の表示などように検索用のmap作成
        const jdProductMap = response.data.data.exProductList.reduce(
          (res, cur) => {
            if (res[cur.exProductNumber]) {
              res[cur.exProductNumber].push(cur)
            } else {
              res[cur.exProductNumber] = [cur]
            }
            return res
          },
          {}
        )
        commit(mutationsTypes.JDPRODUCT_SET_JDPRODUCT_MAP, jdProductMap)

        const getData = getters.getJdproductListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // ESJ02 JD販売商品情報の登録
  registerJdproduct: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    let req = requestJdproductRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.JDPRODUCT_REGISTER_EDIT)
      .post(api.JDPRODUCT_REGISTER_EDIT, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // ESJ03 JD販売商品情報の編集
  editJdproduct: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    let req = requestJdproductEdit.request.createRequest(params)

    return await axios
      // .get(apiMock.JDPRODUCT_REGISTER_EDIT)
      .patch(`${api.JDPRODUCT_REGISTER_EDIT}/${params.id}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // ESJ04 外部商品CSVアップロード
  bulkRegisterJdproduct: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const instance = axios.create({
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    await getCsrfToken()

    return await instance
      .post(api.JDPRODUCT_BULK_REGISTER, params)
      .then((response) => {
        const ret = commonUtil.afterApiSuccessProcess(
          response,
          response.data.data
        )
        return ret
      })
      .catch((error) => {
        if (error.response.data.data && error.response.data.data.errorList) {
          const errors = []
          error.response.data.data.errorList.forEach((ele) => {
            for (const index in ele.errors) {
              ele.errors[index].flat().forEach((error) => {
                const errorMsg =
                  i18n.locale === 'cn'
                    ? `第${ele.lineNumber}行 ${error}`
                    : `${ele.lineNumber}行目 ${error}`
                errors.push(errorMsg)
              })
            }
          })

          alert(`${errors.join('\n')}`)
          return false
        }

        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
